import React, { useContext } from 'react';
import { useRoutes } from 'react-router-dom';
import routes from './routes';
import { AuthContext } from '@/guard/AuthProvider';

function Routing() {
    const { isAuthenticated, permissions, isSuperAdmin } = useContext(AuthContext);

    const routing = useRoutes(routes(isAuthenticated, isSuperAdmin, permissions));

    return routing;
}

export default Routing;
